import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/EmpoweringSection.css";

const EmpoweringSection = () => {
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false); // ✅ Modal state

  const handleDispatchClick = () => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/dispatch-history"); // ✅ Logged in → go straight
    } else {
      setShowAuthModal(true); // 🔥 Show modal if not logged in
    }
  };

  return (
    <section className="empowering-section">
      <div className="empowering-container">

        {/* ✅ Frame Wrapping Everything */}
        <div className="empowering-frame">
          <h2 className="empowering-heading">
            Empowering Users <br /> with seamless speed
          </h2>
          <p className="empowering-subtext">
            Experience seamless speed with our innovative solutions designed to effortlessly 
            send documents with the speed of light and enhance productivity.
          </p>

          {/* ✅ Dispatch Now Button Inside Frame */}
          <button className="dispatch-button" onClick={handleDispatchClick}>
            Dispatch Now
          </button>
        </div>

        {/* ✅ Right Side - Image Frame */}
        <div className="empowering-image-frame">
          <img src="/happy.jpg" alt="Happy User" className="empowering-image" />
        </div>
      </div>

      {/* ✅ Auth Modal */}
      {showAuthModal && (
        <div className="auth-modal-overlay">
          <div className="auth-modal">
            <h3>Login Required</h3>
            <p>
              Hey there! You’ll need to sign in or create an account to dispatch your documents.
            </p>
            <div className="auth-modal-buttons">
              <button onClick={() => navigate("/login")}>Login</button>
              <button onClick={() => navigate("/signup")}>Sign Up</button>
              <button
                onClick={() => setShowAuthModal(false)}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default EmpoweringSection;
